import { render, staticRenderFns } from "./tikcy.vue?vue&type=template&id=2e398452&scoped=true"
import script from "./tikcy.vue?vue&type=script&lang=js"
export * from "./tikcy.vue?vue&type=script&lang=js"
import style0 from "./tikcy.vue?vue&type=style&index=0&id=2e398452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e398452",
  null
  
)

export default component.exports